import { render, staticRenderFns } from "./GoodsRankingDetail.vue?vue&type=template&id=7f8d4f52&scoped=true"
import script from "./GoodsRankingDetail.vue?vue&type=script&lang=ts"
export * from "./GoodsRankingDetail.vue?vue&type=script&lang=ts"
import style0 from "./GoodsRankingDetail.vue?vue&type=style&index=0&id=7f8d4f52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8d4f52",
  null
  
)

export default component.exports